import router from './router'
// import { useAppStoreWithOut } from '@/store/modules/app'
import { debounce } from 'lodash-es'
import type { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useCollect } from '@/hooks/web/useCollect'
import { useBreadcrumb } from '@/hooks/web/useBreadcrumb'
// import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
// import { usePageLoading } from '@/hooks/web/usePageLoading'
import { NO_REDIRECT_WHITE_LIST } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { menuUpMenuAccess, permissionCheck, getWaterMark, saveChartOpr } from '@/api'
import { resetRoot } from '@/utils/routerHelper'
import { handleCloseCurrentTab } from '@/utils/navigation'

import { transformWaterMarkConfig } from '@/utils'

// const { start, done } = useNProgress()

// const { loadStart, loadDone } = usePageLoading()

router.beforeEach(async (to, from, next) => {
  // start()
  // loadStart()
  if (to.path === '/mid') {
    next()
    return
  }
  const permissionStore = usePermissionStoreWithOut()
  let permissionReplace = ''
  // const appStore = useAppStoreWithOut()
  const userStore = useUserStoreWithOut()
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (permissionStore.getIsAddRouters) {
        // getWaterMark({}).then((res) => {
        //   const config = transformWaterMarkConfig(res.data)
        //   userStore.setWaterMark(config)
        // })
        // 更新水印
        if (to.path.indexOf('help/help') == -1) {
          // 非帮助手册 需要水印
          userStore.updateWaterMark()
        } else {
          // 帮助手册 不需要水印
          userStore.updateWaterMark(true)
        }
        if (to.meta?.modelCode || to.meta?.permissionCode) {
          try {
            if (!to.meta?.permissionCode?.match('HELP')) {
              const { data } = await permissionCheck({
                modelCode: to.meta?.modelCode,
                permissionCode: to.meta?.permissionCode
              })
              if (data.checkResult) {
                next()
                return
              } else {
                // 页签tags关闭当前无权限的页签
                handleCloseCurrentTab(to)
                // 跳转页面无权限
                permissionReplace = '/404/access-denied'
              }
            } else {
              next()
              return
            }
          } catch (error) {
            // 跳转页面无权限
            permissionReplace = '/404/access-denied'
            console.error('请求失败:', error)
          }
        } else {
          next()
          return
        }
      }
      try {
        // 从接口获取权限路由
        const roleRouters = await permissionStore.fetchRoutesData()
        // console.log(roleRouters)
        await permissionStore.generateRoutes('server', roleRouters)

        permissionStore.getAddRouters.forEach((route, index) => {
          router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
          // console.log(route)
          // 根目录重定向到有权限的第一页
          const firstRoute = route.name.match(/List$/)
            ? route
            : route.children?.find((r) => r.name.match(/List$/))
          if (firstRoute && !index) {
            router.addRoute(resetRoot(firstRoute.path.replace(':id', firstRoute.meta.modelCode)))
          }
        })
        // 账号无权限处理
        if (!roleRouters.length) {
          permissionReplace = '/404/account-denied'
          router.addRoute(resetRoot(permissionReplace))
          permissionStore.resetRoutes()
        }
        const redirectPath = from.query.redirect || permissionReplace || to.path
        const redirect = decodeURIComponent(redirectPath as string)
        const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
        permissionStore.setIsAddRouters(true)
        // 在无权限页面，刷新后有权限了 fix:http://118.31.78.189:8183/zentao/bug-view-20351.html
        if (to.path === '/404/account-denied') {
          next({ path: '/' })
        }
        next(nextData)
      } catch (e: any) {
        if (
          e?.data?.code === 401 ||
          e?.data?.code === 69080011 ||
          e?.data?.code === 69080018 ||
          e?.data?.code === 690800102
        ) {
          userStore.reset()
          next(`/login?redirect=${to.path}`)
        } else {
          next()
        }
      }
    }
  } else {
    if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  }
})

const upReportAccess = debounce((title) => {
  saveChartOpr({
    chartName: title
  })
}, 50)

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  const { addHistory } = useCollect()
  const { getBreadcrumb } = useBreadcrumb()
  const permissionStore = usePermissionStoreWithOut()
  const { isEntry, permissionCode, modelCode, pageId, title } = to?.meta ?? {}
  // done() // 结束Progress
  // loadDone()

  // 访问上报
  if ((isEntry && to.matched[0]?.name == 'DataReport') || to.name == 'Cockpit') {
    //   menuUpMenuAccess({
    //     permissionCode,
    //     modelCode,
    //     pageId,
    //     menuName: title
    //   }).then(() => {
    //     addHistory(to)
    //   })
    upReportAccess(title)
  }
  // 按钮权限更新
  const levelList = getBreadcrumb(to)
  const entry = levelList.find((r) => r.meta.button)
  permissionStore.setCurrentPermission(entry)
  // 获取配置的resourceCode路由
  const listEntry = levelList.find((r) => r.meta.resourceCode)
  permissionStore.setCurrentEntryCode(isEntry ? to : listEntry)
})
